const layout = 'negotiation-details-layout';
const negotiationDetails = {
  listingTitle: 'listing-title',
  listingEmployer: 'listing-employer',
  respondingEmployer: 'responding-employer',
  modifiedFields: 'modified-fields',
  contractOverviewTab: 'contract-overview-tab',
  shiftDistributionTab: 'shift-distribution-tab',
  compensationTab: 'compensation-tab',
  contractTermsTab: 'contract-terms-tab',
};
const contractForm = {
  startDateInput: 'start-date-input',
  endDateInput: 'end-date-input',
  fteInput: 'fte-input',
  shiftsPerFTE: 'shifts-per-fte-input',
  totalShifts: 'total-shifts',
  hoursPerShiftInput: 'hours-per-shift-input',
};

const shiftDistributionForm = {
  weekDayInput: 'weekday--day-input',
  weekEveningInput: 'weekday-evening-input',
  weekNightInput: 'weekday-night-input',
  weekendDayInput: 'weekend-day-input',
  weekendEveningInput: 'weekend-evening-input',
  weekendNightInput: 'weekend-night-input',
  holidayDayInput: 'holiday-day-input',
  holidayEveningInput: 'holiday-evening-input',
  holidayNightInput: 'holiday-night-input',
};

const compensationForm = {
  compensationTypeSelect: 'compensation-select',
  pricePerHourInput: 'price-per-hour-input',
  pricePerShiftInput: 'price-per-shift-input',
  pricePerRVUInput: 'price-per-rvu-input',
  yearlyRVUInput: 'yearly-rvu-input',
  shiftDiffSelect: 'shift-diff-select',
  weekDayShiftDiff: 'weekday-diff-input',
  weekDayEveningShiftDiff: 'weekEvening-diff-input',
  weekDayNightShiftDiff: 'weekNight-diff-input',
  weekEndDayShiftDiff: 'weekend-day-diff-input',
  weekEndEveningShiftDiff: 'weekend-evening-diff-input',
  weekEndNightShiftDiff: 'weekend-night-diff-input',
  holidayDayShiftDiff: 'holiday-day-diff-input',
  holidayEveningShiftDiff: 'holiday-evening-diff-input',
  holidayNightShiftDiff: 'holiday-night-diff-input',
  previousTotalValue: 'previous-total-value',
  previousAvgHourlyRate: 'previous-avg-hourly-rate',
  proposedTotalValue: 'proposed-total-value',
  proposedAvgHourlyRate: 'proposed-avg-hourly-rate',
  proposedValueDifference: 'proposed-value-difference',
};

const contractTermsForm = {
  bonusInput: 'bonus-input',
  adminCostInput: 'admin-cost-input',
  infrastructureReqsInput: 'infrastructure-req-input',
  extraTermsInput: 'extra-input',
};

const formBtns = {
  closeBtn: 'closeBtn',
  rejectBtn: 'rejectBtn',
  declineBtn: 'declineBtn',
  withdrawBtn: 'withdrawBtn',
  counterBtn: 'counterBtn',
  acceptBtn: 'acceptBtn',
};

export default {
  layout,
  negotiationDetails,
  contractForm,
  shiftDistributionForm,
  compensationForm,
  contractTermsForm,
  formBtns,
};
